import confetti from 'canvas-confetti';

const end = Date.now() + 5 * 1000;

const colors = ['#e73230', '#929aa3'];

/**
 * @see: https://www.kirilv.com/canvas-confetti/
 */
function drawConfettiFrame() {
    confetti({
        particleCount: 3,
        angle: 60,
        spread: 70,
        origin: { x: 0 },
        colors: colors,
    });
    confetti({
        particleCount: 3,
        angle: 110,
        spread: 60,
        origin: { x: 1 },
        colors: colors,
    });

    if (Date.now() < end) {
        requestAnimationFrame(drawConfettiFrame);
    }
}

function fadeInText() {
    const container = document.querySelector('.js-birthday-text');

    if (!container) {
        return;
    }

    const lines = container.querySelectorAll('.js-birthday-text__line');

    lines.forEach((line, index) => {
        setTimeout(() => {
            line.classList.add('js-birthday-text__line--visible');
        }, (index + 1) * 3000);

        if (index !== lines.length - 1) {
            setTimeout(() => {
                line.classList.remove('js-birthday-text__line--visible');
            }, (index + 1) * 4000);
        }
    });
}

if (document.documentElement.classList.contains('js-birthday-effects')) {
    drawConfettiFrame();
    fadeInText();
}
